import React from 'react';

import { useStyles } from './style';
import { Chip, TableCell, TableRow, Typography } from '@material-ui/core';
import { Invoice } from '../../../../../api/payment-method/types';
import clsx from 'clsx';

interface Props {
  invoice: Invoice;
}

export const TransactionItem: React.FC<Props> = ({ invoice }) => {
  const classes = useStyles();

  return (
    <TableRow key={invoice.id} hover className={classes.tableRow}>
      <TableCell component="th" scope="row" className={clsx(classes.featureCell, classes.tableCell)}>
        {invoice.product_name}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {invoice.invoice_date}
      </TableCell>
      <TableCell className={clsx(classes.tableCell)}>
        <Chip
          label={invoice.invoice_status === 'paid' ? 'PAID' : 'RETRYING'}
          color={'secondary'}
          className={clsx(
            classes.defaultChip,
            invoice.invoice_status === 'paid' && classes.paidChip,
          )}
        />
      </TableCell>
      <TableCell className={classes.tableCell}>
        {invoice.invoice_status === 'paid' && <a className={classes.invoiceLink} href={invoice.invoice_url} target="_blank" rel="noopener noreferrer">
          Get Invoice
        </a>}
      </TableCell>
    </TableRow>
  );
};